import React, { useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import { AgGridReact } from "ag-grid-react";
import EmailEditModal from "./EditEmailModal";
import ViewModiyRenderer from "../Renderers/ViewModiyRenderer";
import "./EmailAdmin.css";

const EmailAdmin = ({ emailAdmin, isEmailAdmin, getEmailAdminDetail }) => {
  const [emailToEdit, setEmailToEdit] = useState(null);
  const [showEmailEditModal, setShowEmailEditModal] = useState(false);

  const modifyEmailHandler = (data) => {
    if (data) {
      setShowEmailEditModal(true);
      const mapRecipts = {
        Primary: "Vendor-Primary",
        Technical: "Vendor-Technical/EDI",
        CustomerService: "Vendor-Customer",
        Shipping: "Vendor-Shipping",
        Merchant: "Merchant",
        vdfMerchantOpsManager: "VDF Merchant Manager",
        vdfOpsAdmin: "VDF Admin",
        vdfOpsPipelineOwner: "Pipeline Owner",
        accountsPayableAdmin: "AP Admin",
        bigticketAdmin: "BT Admin",
        Other: "Vendor-Other",
      };
      const ccList =
        data.cc &&
        data.cc.map((item) => {
          return mapRecipts[item] || item;
        });
      data.cc = ccList;
      const recieptList =
        data.recipients &&
        data.recipients.map((item) => {
          return mapRecipts[item] || item;
        });
      data.recipients = recieptList;
      setEmailToEdit(data);
    }
  };

  const closeEmailEditModalHandler = () => {
    setShowEmailEditModal(false);
    setEmailToEdit(null);
  };
  const columnDefs = [
    {
      headerName: "Short Description",
      field: "title",
      width: 370,
      resizable: false,
      sortable: false,
      filter: false,
    },
    {
      headerName: "Touch Point",
      field: "touchPointDesc",
      width: 130,
      comparator: stringDataComparator,
    },
    {
      headerName: "Vendor Fulfillment Type",
      field: "fulfillmentTypeDesc",
      width: 160,
      comparator: stringDataComparator,
    },
    {
      headerName: "Vendor Connection",
      field: "vendorConnectionDesc",
      width: 150,
      comparator: stringDataComparator,
    },
    {
      headerName: "Selling Channel",
      field: "sellingChannel",
      width: 150,
      comparator: stringDataComparator,
    },
    {
      headerName: "Last Activity",
      field: "lastActivity",
      width: 140,
      comparator: dateComparator,
    },
    {
      headerName: "Active?",
      field: "active",
      width: 80,
      comparator: stringDataComparator,
    },
    {
      headerName: "View/Modify",
      field: "viewModify",
      width: 130,
      resizable: false,
      sortable: false,
      filter: false,
      cellRendererFramework: ViewModiyRenderer,
      cellRendererParams: { emailTemplateEditHandler: modifyEmailHandler },
    },
  ];
  const defaultColDef = {
    lockVisible: true,
    suppressMovable: true,
    filter: true,
    sortable: true,
    resizable: true,
  };

  function stringDataComparator(valueA, valueB) {
    const valueALower =
      valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
    const valueBLower =
      valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
    if (valueALower && valueBLower) {
      return valueALower === valueBLower
        ? 0
        : valueALower.localeCompare(valueBLower, "en", { numeric: true });
    } else if (valueALower && (valueBLower === null || valueBLower === "")) {
      return -1;
    } else if ((valueALower === null || valueALower === "") && valueBLower) {
      return 1;
    } else {
      return -1;
    }
  }

  function dateComparator(date1, date2) {
    let date1Number = Date.parse(date1);
    let date2Number = Date.parse(date2);
    if (
      (isNaN(date1Number) || date1Number === null) &&
      (isNaN(date2Number) || date2Number === null)
    ) {
      return 0;
    }
    if (isNaN(date1Number) || date1Number === null) {
      return -1;
    }
    if (isNaN(date2Number) || date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
  }

  return (
    <div className="emailAdmin">
      <LoadingOverlay active={isEmailAdmin} spinner>
        <div className="ag-theme-balham emailAdminTable">
          <AgGridReact
            columnDefs={columnDefs}
            rowData={emailAdmin}
            defaultColDef={defaultColDef}
            rowSelection="multiple"
            paginationPageSize="20"
            pagination={true}
            overlayNoRowsTemplate={
              emailAdmin.length > 0 ? "" : "No Email Admin details available."
            }
          />
        </div>
      </LoadingOverlay>
      {showEmailEditModal && emailToEdit && (
        <EmailEditModal
          emailToEdit={emailToEdit}
          modalCloseHandler={closeEmailEditModalHandler}
          getEmailAdminDetail={getEmailAdminDetail}
        />
      )}
    </div>
  );
};

export default EmailAdmin;
